import Alpine from "alpinejs";

document.addEventListener('alpine:init', () => {
	Alpine.data("password", () => ({
		show: false,
		trigger: {
			['@click.prevent']() {
				this.show = !this.show;
			},

		},
		input: {
			[':type']() {
				return this.show ? 'text' : 'password';
			},
		},
	}));
});

Alpine.start();
